import { styled } from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  padding-bottom: 48px;
  max-width: 900px;
  margin: 0 auto;
  text-align: center;

  ${({ theme }) => theme.breakpoints.md.query} {
    text-align: left;
  }
`;

export const ItemWrapper = styled.div<{ $inverted: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 96px 24px;
  background-color: ${({ theme, $inverted }) =>
    $inverted ? theme.colors.default[50] : "transparent"};

  ${({ theme }) => theme.breakpoints.md.query} {
    padding: 96px 24px;
  }
`;

export const VideoInnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  overflow: hidden;
  width: 600px;
  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 630px;
  overflow: hidden;

  & > img {
    border-radius: 24px;
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }

  &:first-of-type {
    grid-area: text;
  }

  &:last-of-type {
    grid-area: image;
  }
`;

export const ItemContainer = styled.div<{ $flex?: boolean; $flip?: boolean }>`
  width: 100%;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  gap: 94px;
  display: flex;
  justify-content: center;
  flex-direction: ${({ $flip }) => ($flip ? "row-reverse" : "row")};

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column-reverse;
    gap: 32px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding-top: 12px;
`;

export const Subtitle = styled.h4`
  font-size: 20px;
  line-height: 26px;
  text-transform: uppercase;
`;

export const Title = styled.h3`
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: 0.03em;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.default[500]};
  padding: 12px 0 12px 0;
  font-size: 17px;
  font-weight: 550;
  line-height: 25.5px;
  width: 100%;
  white-space: pre-wrap;
  & > a {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;

export const Paragaphs = styled.div`
  color: ${({ theme }) => theme.colors.default[500]};
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 0 12px 0;
`;

export const Image = styled.img`
  height: 100%;
  width: 100%;
`;

export const BulletPointContainer = styled.div`
  display: flex;
  padding-top: 12px;
  padding-bottom: 12px;
  flex-direction: column;
  align-items: flex-start;
  max-height: 230px;
  flex-wrap: wrap;
  gap: 8px;
  align-self: stretch;
  & > div {
    color: ${({ theme }) => theme.colors.default[500]};
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    max-height: 100%;
  }
`;

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 500px;
  ${({ theme }) => theme.breakpoints.md.query} {
    max-width: 100%;
  }
`;

export const LinkContentItem = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.default[50]};
  color: ${({ theme }) => theme.colors.primary.default};
`;

export const CarouselWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.default[50]};
  height: 423px;
`;

export const Card = styled.div`
  background: white;
  width: 630px;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 36px;
  height: 100%;
  ${({ theme }) => theme.breakpoints.md.query} {
    width: 100%;
  }
`;

export const QuoteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`;

export const QuoteArea = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

export const Dot = styled.button<{ $active: boolean }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.primary.default};
  background: ${({ $active, theme }) =>
    $active ? theme.colors.primary.default : "transparent"};
  cursor: pointer;
  transition:
    background 0.3s,
    transform 0.2s;
  transform: scale(1.1);
`;

export const HoverZoneLeft = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 10%;
  height: 100%;
  z-index: 2;
  &:hover > button {
    opacity: 1;
  }
`;

export const HoverZoneRight = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 10%;
  height: 100%;
  z-index: 2;
  &:hover > button {
    opacity: 1;
  }
`;

export const ArrowLeft = styled.button`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  cursor: pointer;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.primary.default};
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  z-index: 2;
`;

export const ArrowRight = styled(ArrowLeft)`
  left: auto;
  right: 16px;
`;
